import React from 'react';
import Navigate from './scripts/navigator'
import { Platform, View } from 'react-native';
import { useFonts } from 'expo-font';

export default function App() {
  const [fontsLoaded] = useFonts({
    'times': require('./assets/fonts/times.ttf'),
    'times-bold': require('./assets/fonts/timesbd.ttf'),
    'times-italic': require('./assets/fonts/timesi.ttf'),
    'futuris': require('./assets/fonts/futuris.ttf')
  });
  
  if (Platform.OS != 'web' && !fontsLoaded) {
    return null;
  }

  return (
    <View style={ { flex: 1 } }>
      <Navigate />
    </View>
  );
}